<template>
    <TopBar/>
    <Aside v-if="this.current_editor === 'ACCOUNT'"/>
    <AsideUserList v-if="this.current_editor === 'USER'"/>
    <AsideGroupList v-if="this.current_editor === 'GROUP'"/>
    <div v-if="this.current_editor === 'NONE'" class="aside"></div>
    <ManagementContent/>
</template>

<script>
import TopBar from '../components/TopBar.vue'
import Aside from '../components/Aside.vue'
import AsideUserList from '../components/AdminArea/AsideUserList.vue'
import AsideGroupList from '../components/AdminArea/AsideGroupList.vue'
import ManagementContent from '../components/AdminArea/ManagementContent.vue'

export default {
    name: 'Management',
    data() {
        return {}
    },
    components: {
        TopBar, Aside, AsideUserList, AsideGroupList, ManagementContent
    },
    methods: {},
    computed: {
        current_editor() {
            return this.$store.state.current_editor
        },
        accountName() {
            return this.$store.state.current_acc
        },
        userName() {
            return this.$store.state.current_user
        },
    }
}
</script>

<style scoped>

#app {
    height: 100vh;
}

</style>